import React, { Component } from "react";

import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";

type MinitProps = {
  time: number;
};

class Completed extends Component {
  render() {
    return (
      <span className="text-[18px] text-[#fb8500] font-[700]">
        Mint finished
      </span>
    );
  }
}

export const Countdown = ({ time }: MinitProps) => {
  return (
    <FlipClockCountdown
      to={new Date(time * 1000)}
      labelStyle={{
        fontSize: 12,
        fontWeight: 500,
        color: "#ffffac",
        textTransform: "uppercase",
      }}
      digitBlockStyle={{
        width: 20,
        height: 30,
        fontSize: 16,
        color: "#fedb37",
      }}
      separatorStyle={{ color: "#ffffac" }}
    >
      <Completed />
    </FlipClockCountdown>
  );
};
